import React from 'react'
import './styles/SendEmail.scss'
// import pops from '../../components/SendEmailPHP/cont.php'

export default class SendEmailNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            error: false,
            isLoaded: false,
            items: [],
            name: '',
            tel: '',
            email: '',
            message: '',
            checkCase: '',
            loader: false,
            success: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleCheckChange = this.handleCheckChange.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.name === 'select' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleCheckChange(event) {
        const target = event.target;
        const value = target.id;

        this.setState({
            checkCase: value,
        });
        if (target.name === 'name') {
            this.setState({
                name: target.value,
            })
        }
        if (target.name === 'email') {
            this.setState({
                email: target.value,
            })
        }
        if (target.name === 'message') {
            this.setState({
                message: target.value
            })
        }
    }

    handleSubmit(event){
        event.preventDefault();
        let th = this;
        this.setState({
            loader: true,
        });
        fetch('/email/sendCase.php', {
            method: 'post',
            headers: {
                'Content-Type':'application/x-www-form-urlencoded',
                'Accept':'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                name: th.state.name,
                email: th.state.email,
                message: th.state.message,
                select: th.state.checkCase
            }).toString()
        })
            .then(function(response) {
                    if (response.ok) {
                        th.setState({
                            error: false,
                        });
                        th.loaderSendNew()
                    } else {
                        th.setState({
                            success: false
                        });
                        th.errorSendNew()
                    }
            })
            .catch(function() {
                th.setState({ success: false });
                th.errorSendNew()
            })
    };

    loaderSendNew() {
        setTimeout(() => {
            this.setState({
                loader: false,
                success: true,
                name: '',
                tel: '',
                email: '',
                message: '',
                checkCase: ''
            })
        }, 2000);
        setTimeout(() => {
            this.setState({
                success: false
            })
        }, 6000)
    }

    errorSendNew() {
        setTimeout(() => {
            this.setState({
                loader: false,
                error: true,
            })
        }, 2000);
        setTimeout(() => {
            this.setState({
                error: false
            })
        }, 4000)
    }

    setType = (value) => {
        this.setState({
            checkCase: value
        })
    };

    open() {
        this.setState({
            open: true
        })
    };

    close() {
        this.setState({
            open: false
        })
    };

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render() {

        let { sections } = this.props;

        return (
            <React.Fragment>
                <div className={`send-email ${this.state.open ? 'send-email--on' : ''}`}>
                    <div className="send-email__container">
                        <div
                            className="send-email__container--close"
                            onClick={() => {
                                this.close()
                            }}
                        >
                            X
                        </div>
                        <div className="send-email__container--title">
                            Заполните форму ниже, после чего с вами свяжется наш менеджер.
                        </div>
                        <form
                            className="send-email__container--form"
                            onSubmit={this.handleSubmit}
                        >
                            <div className="send-email__container--form--input">
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Имя"
                                    value={this.state.name}
                                    onChange={this.handleInputChange}
                                    pattern="[A-Za-zА-Яа-я]{1,32}"
                                    required="required"
                                />
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="E-mail"
                                    value={this.state.email}
                                    onChange={this.handleInputChange}
                                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                                    required="required"
                                />
                            </div>
                            <div className="send-email__container--form--text">
                                <textarea
                                    name="message"
                                    cols="40"
                                    rows="5"
                                    value={this.state.message}
                                    onChange={this.handleInputChange}
                                    required="required"
                                    placeholder="Текст"
                                />
                            </div>
                            <div className="send-email__container--form--button--block">
                                <button
                                    className={`send-email__container--form--button ${this.state.error ? 'send-email__container--form--button--error' : this.state.success ? 'send-email__container--form--button--success' : ''}`}
                                    type="submit"
                                    disabled={this.state.loader}
                                >
                                    <div className={`send-email__container--form--button--loader ${this.state.loader ? 'send-email__container--form--button--loader--yes' : ''}`}>
                                    </div>
                                    {
                                        this.state.success ?
                                            <div className="send-email__container--form--button--text">
                                                Отправлено
                                            </div>
                                            :
                                            this.state.error ?
                                                <div className="send-email__container--form--button--text">
                                                    Ошибка
                                                </div>
                                                :
                                                <div className={`send-email__container--form--button--text ${this.state.loader ? 'send-email__container--form--button--text--no' : ''}`}>
                                                    Отправить
                                                </div>
                                    }
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
